import React, {Component} from 'react';
import faq9 from "../../../../../../assets/img/faq9.png";
import faq10 from "../../../../../../assets/img/faq10.png";
import {Link} from "react-router-dom";
import '../FaqPages/AboutPayment.css';
import FocusPageId from "../../FocusPageId";
import '../Beginners.css'

class MemberRegistration extends React.Component {
    constructor(props) {
        super(props);

        this.focusPage = this.focusPage.bind(this);

    }

    focusPage = (elementId) => {
        FocusPageId.selectedId = {elementId}
    }

    componentDidMount() {
        window.scrollTo(0, 0)
    }

    render() {

        return (
            <div className="static-pages">
                <div className="background-div ">

                        <h3><b>
                            <span>支払いについて</span>
                        </b></h3>
                         <div className="brElement"></div>
                        <div onClick={() => this.focusPage("a")}>
                            <Link to='/aboutpayment'>
                                <h4><b className="reduce-font-size cart-row-text-color"> 支払い方法を教えてください。</b>
                                </h4>
                            </Link>

                        </div>

                         <div className="brElement"></div>
                        {/*<div onClick={() => this.focusPage("b")}>*/}
                            {/*<Link to='/aboutpayment'>*/}
                                {/*<h4><b className="reduce-font-size cart-row-text-color"> 何故、支払い方法がPayPalなのか？</b>*/}
                                {/*</h4>*/}
                            {/*</Link>*/}

                        {/*</div>*/}

                         {/*<div className="brElement"></div>*/}


                        <div onClick={() => this.focusPage("c")}>
                            <Link to='/aboutpayment'>
                                <h4><b className="reduce-font-size cart-row-text-color"> 紙で領収書を発行してもらえますか？</b>
                                </h4>
                            </Link>

                        </div>

                         <div className="brElement"></div>

                        <div onClick={() => this.focusPage("d")}>
                            <Link to='/aboutpayment'>
                                <h4><b className="reduce-font-size cart-row-text-color"> 注文後に請求書、領収書等の宛名を変更することはできますか？</b>
                                </h4>
                            </Link>

                        </div>
                         <div className="brElement"></div>
                        <div onClick={() => this.focusPage("e")}>
                            <Link to='/aboutpayment'>
                                <h4><b className="reduce-font-size cart-row-text-color">2つ以上の注文について各種書類（注文明細、請求書兼領収書）をまとめることは可能ですか？</b>
                                </h4>
                            </Link>

                        </div>

                        {/*<div className='col-md-10'></div>*/}
                        <div className='faq-link-float-right col-12-custom '>
                            <Link to="/frequent">
                            <span className='font-size-20 reduce-font-size'>
                            戻る
                            </span>
                            </Link>
                        </div>

                </div>
            </div>
        );
    }
}

export default MemberRegistration;




// WEBPACK FOOTER //
// ./src/components/Site/SiteRoot/Navigation/LinkPages/FaqTopicsPages/AboutPaymentTopics.js